var map = {
	"./automn/fog.png": "1d30",
	"./automn/ground.png": "21fc",
	"./automn/leaf_1.png": "bd20",
	"./automn/leaf_2.png": "9208",
	"./automn/leaf_3.png": "4571",
	"./automn/leaf_4.png": "85e8",
	"./automn/leaf_5.png": "c6a5",
	"./automn/lf1.png": "3a0f",
	"./automn/lf2.png": "69eb",
	"./automn/lf3.png": "0770",
	"./automn/lf4.png": "f391",
	"./automn/lf5.png": "65a9",
	"./automn/lf6.png": "7ca6",
	"./automn/lf7.png": "f26e",
	"./automn/lf8.png": "aafb",
	"./automn/water.png": "277e",
	"./global/arbre_1.png": "074e",
	"./global/arbre_1_ombre.png": "4132",
	"./global/arbre_2.png": "ce93",
	"./global/arbre_2_ombre.png": "2574",
	"./global/arbre_3.png": "0490",
	"./global/arbre_3_ombre.png": "0ab3",
	"./global/arbre_4.png": "92d8",
	"./global/arbre_4_ombre.png": "2f53",
	"./global/arbre_5.png": "b41a",
	"./global/arbre_5_ombre.png": "4a49",
	"./global/daniel.png": "1bf2",
	"./global/ombre.png": "94ad",
	"./global/silhouette.png": "b2a0",
	"./global/sun.png": "24ed",
	"./spring/fog.png": "a279",
	"./spring/ground.png": "f0a9",
	"./spring/leaf_1.png": "fa61",
	"./spring/leaf_2.png": "26df",
	"./spring/lf1.png": "0a6a",
	"./spring/lf2.png": "87fe",
	"./spring/lf3.png": "175d",
	"./spring/lf4.png": "14ba",
	"./spring/lf5.png": "6223",
	"./spring/lf6.png": "fddb",
	"./spring/lf7.png": "6e27",
	"./spring/lf8.png": "5f01",
	"./summer/bird_1.png": "dbac",
	"./summer/bird_2.png": "44e1",
	"./summer/bird_3.png": "93a4",
	"./summer/bird_4.png": "b389",
	"./summer/fog.png": "bc54",
	"./summer/grasse_1.png": "3e7e",
	"./summer/grasse_2.png": "cb98",
	"./summer/grasse_21.png": "a27a",
	"./summer/grasse_3.png": "6844",
	"./summer/grasse_4.png": "99dc",
	"./summer/grasse_5.png": "d717",
	"./summer/grasse_6.png": "3b1f",
	"./summer/grasse_7.png": "5f50",
	"./summer/grasse_8.png": "1095",
	"./summer/ground.png": "439b",
	"./summer/leaf_1.png": "cac5",
	"./summer/leaf_2.png": "2666",
	"./summer/leaf_3.png": "c21c",
	"./summer/leaf_4.png": "ebc6",
	"./summer/leaf_5.png": "2b95",
	"./winter/clouds_1.png": "14be",
	"./winter/clouds_2.png": "15db",
	"./winter/clouds_3.png": "900e",
	"./winter/clouds_4.png": "420d",
	"./winter/clouds_5.png": "f22c",
	"./winter/clouds_6.png": "c9fc",
	"./winter/fog.png": "a1b0",
	"./winter/ground.png": "74b3",
	"./winter/ground_1.png": "8d8e",
	"./winter/ground_2.png": "df27",
	"./winter/ground_3.png": "ed0a",
	"./winter/ground_4.png": "1e6f",
	"./winter/snow.png": "624a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7408";